import { render, staticRenderFns } from "./sendTransferDetail.vue?vue&type=template&id=fdba6ca2&"
import script from "./sendTransferDetail.vue?vue&type=script&lang=js&"
export * from "./sendTransferDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports